module.exports = __webpack_public_path__ + "img/4_133.563c4064.png";